"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryFetch = exports.delay = exports.generateIdentitiesData = void 0;
var node_fetch_1 = __importDefault(require("node-fetch"));
// @ts-ignore
if (typeof node_fetch_1.default.default !== 'undefined')
    node_fetch_1.default = node_fetch_1.default.default;
function generateIdentitiesData(identifier, traits) {
    var traitsGenerated = Object.entries(traits).map(function (trait) { return ({
        trait_key: trait[0],
        trait_value: trait[1]
    }); });
    return {
        identifier: identifier,
        traits: traitsGenerated
    };
}
exports.generateIdentitiesData = generateIdentitiesData;
var delay = function (ms) {
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(undefined); }, ms); });
};
exports.delay = delay;
var retryFetch = function (url, fetchOptions, retries, timeout // set an overall timeout for this function
) {
    if (retries === void 0) { retries = 3; }
    if (timeout === void 0) { timeout = 10; }
    return new Promise(function (resolve, reject) {
        var retryWrapper = function (n) {
            requestWrapper()
                .then(function (res) { return resolve(res); })
                .catch(function (err) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(n > 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, (0, exports.delay)(1000)];
                        case 1:
                            _a.sent();
                            retryWrapper(--n);
                            return [3 /*break*/, 3];
                        case 2:
                            reject(err);
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        };
        var requestWrapper = function () {
            return new Promise(function (resolve, reject) {
                var timeoutId;
                if (timeout) {
                    timeoutId = setTimeout(function () { return reject('error: timeout'); }, timeout);
                }
                return (0, node_fetch_1.default)(url, fetchOptions)
                    .then(function (res) { return resolve(res); })
                    .catch(function (err) { return reject(err); })
                    .finally(function () {
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                });
            });
        };
        retryWrapper(retries);
    });
};
exports.retryFetch = retryFetch;
